/** Mock function / utility */
const noop = (): void => {};

export default noop;
